export { default as IndexTableHeaderEmptyCell } from './IndexTableHeaderEmptyCell';
